import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import localforage from "localforage";
import { DeviceFragment } from "./fragments/device";
import { STORAGE_KEYS } from "~/libs/storage-keys";
import { useDeviceId, useSetDeviceId } from "~/store";
import { gqlReq } from "~/libs/gql";
import {
	CreateNewDeviceDocument,
	GetCurrentDeviceDocument,
} from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		query GetCurrentDevice {
			getCurrentDevice {
				...DeviceFragment
			}
		}
		${DeviceFragment}
	`
);
void (
	/* GraphQL */ `
		mutation CreateNewDevice {
			createNewDevice {
				...DeviceFragment
			}
		}
		${DeviceFragment}
	`
);

export const getCurrentDeviceQueryKey = () => ["device"];

export const useGetCurrentDevice = () => {
	const [ready, setReady] = useState(false);
	const deviceId = useDeviceId();
	const setDeviceId = useSetDeviceId();

	useEffect(() => {
		async function start() {
			const cachedDeviceId = await localforage.getItem<string>(
				STORAGE_KEYS.DEVICE_ID,
			);
			if (cachedDeviceId) setDeviceId(cachedDeviceId);
			setReady(true);
		}

		void start();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return useQuery({
		enabled: deviceId ? true : ready,
		queryKey: getCurrentDeviceQueryKey(),
		queryFn: ({ signal }) =>
			deviceId
				? gqlReq({
						document: GetCurrentDeviceDocument,
						signal,
					}).catch(() =>
						gqlReq({
							document: CreateNewDeviceDocument,
							requestHeaders: {},
						}),
					)
				: gqlReq({
						document: CreateNewDeviceDocument,
					}),
		onSuccess: async (data) => {
			if (!data) return;
			await localforage.setItem(STORAGE_KEYS.DEVICE_ID, data._id);
			setDeviceId(data._id);
		},
	});
};
